<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <label
            class="v-label v-label--active theme--light"
            style="height: 20px; line-height: 20px; font-size: 13px;"
        >
          Kwota
        </label>
        <v-range-slider
            v-model="debouncedFilters.amount"
            :min="0"
            :max="10000"
            hide-details
            class="align-center"
        >
          <template v-slot:prepend>
            <v-text-field
                :value="debouncedFilters.amount[0]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
                @change="$set(debouncedFilters.amount, 0, $event)"
            />
          </template>
          <template v-slot:append>
            <v-text-field
                :value="debouncedFilters.amount[1]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
                @change="$set(debouncedFilters.amount, 1, $event)"
            />
          </template>
        </v-range-slider>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="30"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="createdAt"
                label="Data utworzenia"
                prepend-icon="mdi-calendar-blank"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
                hide-details
            />
          </template>
          <v-date-picker
              v-model="createdAtRange"
              range
              show-adjacent-months
              :first-day-of-week="1"
              :max="maxDate"
              @change="onCreatedAtChanged"
          />
        </v-menu>
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-3 pt-0"
            v-model="statuses.NEW"
            :label="getTransactionStatusText(transactionStatus.NEW)"
            hide-details
            @click="onStatusSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Świeżo utworzone płatności.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="statuses.PENDING"
            :label="getTransactionStatusText(transactionStatus.PENDING)"
            hide-details
            @click="onStatusSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>

            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="statuses.WAITING_FOR_CONFIRMATION"
            :label="getTransactionStatusText(transactionStatus.WAITING_FOR_CONFIRMATION)"
            hide-details
            @click="onStatusSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>

            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="statuses.CANCELED"
            :label="getTransactionStatusText(transactionStatus.CANCELED)"
            hide-details
            @click="onStatusSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Anulowana przez klienta, admina lub z poziomu Panelu PayU. Status ostateczny.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="statuses.COMPLETED"
            :label="getTransactionStatusText(transactionStatus.COMPLETED)"
            hide-details
            @click="onStatusSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Opłacono. Status ostateczny.
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.buyerId"
            label="ID kupującego"
            placeholder=" "
            :counter="10"
            :rules="rules.idFilter"
            hint="Tylko cyfry, bez #."
            persistent-hint
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="pt-0"
            v-model="debouncedFilters.payU_orderId"
            label="ID zamówienia PayU"
            placeholder=" "
            :counter="27"
            :rules="rules.idFilter"
            hint="Bez #."
            persistent-hint
        />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";
import formatters from "@/mixins/formatters";
import {
  TransactionStatus,
  getStatusName as getTransactionStatusName,
  getStatusText as getTransactionStatusText,
} from "@/enums/TransactionStatus";

export default {
  mixins: [
    formatters,
  ],
  data() {
    return {
      menu1: false,
      createdAtRange: [null, null],
      statuses: {
        CANCELED: false,
        COMPLETED: false,
        NEW: false,
        PENDING: false,
        WAITING_FOR_CONFIRMATION: false,
      },
      filterDebouncing: null,
      standardFilters: {
        statuses: null,

        createdAtFrom: null,
        createdAtTo: null,
      },
      debouncedFilters: {
        buyerId: '',
        payU_orderId: '',
        quantity: [1, 12],
        amount: [0, 10000],

        delayInMinutes: [0, 2880],
        hours: [0, 23],
      },
      rules: {
        textFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
        idFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 1 || 'Wpisz co najmniej jeden znak.'
          },
        ],
      },
    };
  },
  created() {
    this.filterDebouncing = debounce(function () {
      this.filter();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filter();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterDebouncing();
      },
      deep: true
    },
  },
  computed: {
    createdAt: {
      get() {
        return this.createdAtRange.filter((date) => {
          return null !== date;
        }).join(' - ');
      },
      set(dateRange) { // Called when user clicks "X" button to clear the text-field.
        if (null === dateRange) {
          dateRange = [null, null];
        }

        this.createdAtRange = dateRange;
        this.onCreatedAtChanged(dateRange); // Trigger the callback manually.
      }
    },
    maxDate() {
      return this.isoDateTime(new Date());
    },
    transactionStatus() {
      return TransactionStatus;
    },
  },
  methods: {
    quantity(range) {
      const from = range[0] || 0
      const to = range[1] || 0

      return `${from} - ${to}`
    },
    onCreatedAtChanged(dateRange) {
      this.menu1 = false;
      this.standardFilters.createdAtFrom = dateRange[0];
      this.standardFilters.createdAtTo = dateRange[1];
    },
    onStatusSwitched() {
      const statuses = [];

      for (const [name, isChecked] of Object.entries(this.statuses)) {
        if (isChecked) {
          statuses.push(name);
        }
      }

      this.standardFilters.statuses = statuses;
    },
    filter() {
      this.$root.$emit('loadOrders', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
    getTransactionStatusName(status) {
      return getTransactionStatusName(status);
    },
    getTransactionStatusText(status) {
      return getTransactionStatusText(status);
    },
  }
}
</script>